import {
  Spinner_v2 as Spinner,
  Typography,
  Container_v2 as Container,
  TypographyVariantsEnum,
} from '@mindly/ui-components';
import { memo, useMemo } from 'react';
import classNames from 'classnames';
import { isPlatform } from '@ionic/react';
import { useTranslation } from 'react-i18next';

interface LoadingContainerFeatureProps {
  isOnboardingSkipped: boolean;
  showWebToWebAuth?: boolean;
}

function LoadingContainerFeature({ isOnboardingSkipped, showWebToWebAuth }: LoadingContainerFeatureProps) {
  const isWeb = isPlatform('mobileweb') || isPlatform('desktop');
  const { t } = useTranslation('auth');

  const loadingTitle = useMemo(() => {
    if (isOnboardingSkipped) {
      return t('splash.screen.text');
    }
    if (showWebToWebAuth) {
      return t('auth.start.webTitle');
    }
    return t('auth.start.title');
  }, [isOnboardingSkipped, showWebToWebAuth]);

  return (
    <div className="h-full w-full absolute top-0 left-0 z-[100]">
      <Container isFlexContainer>
        <div className={'flex-1 flex items-center justify-center'}>
          <div className={'flex flex-col items-center'}>
            <div className={'text-app mb-6'}>
              <Spinner size={64} />
            </div>
            <Typography
              variant={TypographyVariantsEnum.Title28Semi}
              align={'center'}
              className={classNames('mb-2', {
                'max-w-[295px]': isWeb,
              })}
            >
              {loadingTitle}
            </Typography>
            <Typography variant={TypographyVariantsEnum.Text14Regular} align={'center'} opacity={50}>
              {t(showWebToWebAuth ? 'auth.start.webToWebDescription' : 'auth.start.description')}
            </Typography>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default memo(LoadingContainerFeature);
